import React from "react";
import useHover from "../hooks/useHover";

const BoxFieldOption = ({ name, icon, onClick, click, selected }) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="divRow"
      style={{
        cursor: "pointer",
        opacity: selected == click || hover.hover ? 1 : 0.5,
        padding: "5px",
        borderRadius: ".5rem/.5rem",
        border: "3px solid grey",
        justifyContent: "center",
        width: "270px",
        marginLeft: "5px",
        alignContent: "center",
        marginRight: "5px",
        backgroundColor: "#bfbfbf",
      }}
      onClick={() => onClick(click)}
    >
      <div className="textBold" style={{ flex: 1, textAlign: "center" }}>
        {name}
      </div>
      <img src={icon} className="icon25" />
    </div>
  );
};

export default BoxFieldOption;
